import React from 'react';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LegalNoticeModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  return (
    <ModalBase isOpen={isOpen} onClose={onClose} title="Aviso Legal">
      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-3">Información de conformidad con la Llei 20/2014</h3>
        <p>De conformidad con la Llei 20/2014, del 16 d’octubre, reguladora de la contractació electrònica i dels operadors que desenvolupen la seva activitat econòmica en un espai digital, el titular de esta web es:</p>
        <ul className="list-disc list-inside my-4 space-y-1">
          <li><strong>Identidad:</strong> Gestions Legals Europees, S.L.U.</li>
          <li><strong>NRT:</strong> L-715839-B</li>
          <li><strong>Dirección:</strong> Carrer de la Unió, 5, AD500 Andorra la Vella, Principat d'Andorra</li>
          <li><strong>Tel.:</strong> <a href="tel:+346555345" className="text-blue-600 hover:underline">+346 555 345</a></li>
          <li><strong>Email:</strong> <a href="mailto:informaci%C3%B3n@multas.eu" className="text-blue-600 hover:underline">información@multas.eu</a></li>
          <li><strong>Datos registrales:</strong> Inscrita en el Registre de Societats del M.I. Govern d'Andorra, amb el número 21054, Llibre S-315, Foli 125-130.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-3">Condiciones de uso</h3>
        <p>
            El uso de esta web implica la aceptación plena de los términos y condiciones del presente aviso legal. Los posibles conflictos relativos a esta web se regirán exclusivamente por el derecho del Principado de Andorra. Toda persona usuaria de la web, independientemente de la jurisdicción territorial desde la que se produzca su acceso, acepta el cumplimiento y respeto de estas cláusulas con renuncia expresa a cualquier otro fuero que pudiera corresponderle.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-3">Propiedad intelectual e industrial</h3>
        <p>
            La totalidad del contenido de este sitio web, ya sean textos, imágenes, sonidos, marcas, logotipos u otros elementos, así como subestructura, diseño, combinaciones de colores o forma de presentación de los materiales, están protegidos por derechos de propiedad industrial e intelectual que el usuario de este sitio web debe respetar. No es lícita su transformación o alteración, comunicación pública o cualquier otra forma de explotación por cualquier procedimiento sin la autorización expresa de Gestions Legals Europees, S.L.U.
        </p>
      </section>

      <section className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-3">Responsabilidad sobre los contenidos</h3>
        <p>
            Aunque Gestions Legals Europees, S.L.U., actúa con la máxima diligencia posible, puede darse el caso de que algún dato o información no esté del todo actualizada en el momento que el usuario del sitio web lo consulte. Por ello, las informaciones que se presentan en esta web tienen una función orientativa y no obligan a Gestions Legals Europees, S.L.U.
        </p>
        <p className="mt-2">
            Gestions Legals Europees, S.L.U., no será responsable de la información que se pueda obtener a través de enlaces incluidos en su web.
        </p>
         <p className="mt-2">
            Gestions Legals Europees, S.L.U., se reserva la facultad de realizar, en cualquier momento y sin necesidad de preaviso, modificaciones o actualizaciones de la información y de cualquiera de los elementos que integren el diseño y configuración de la página web.
        </p>
      </section>

      <section>
        <h3 className="text-xl font-semibold text-gray-700 mb-3">Ley aplicable y jurisdicción</h3>
        <p>
            El uso de este sitio web implica la aceptación plena de los términos y condiciones de la presente política legal. Los posibles conflictos relativos a esta web se regirán exclusivamente por la legislación andorrana, siendo competentes los Juzgados y Tribunales andorranos para conocer de cuantas cuestiones se susciten sobre ella. El usuario, por virtud de su aceptación renuncia expresamente a cualquier fuero que por aplicación de la Ley de Enjuiciamiento Civil vigente pudiera corresponderle.
        </p>
      </section>
    </ModalBase>
  );
};
